export default __webpack_public_path__ + "images/8492265c86af9273810b014dec26fd42-festivals_mobile.webp";